import { gql } from "@apollo/client";

export const ACCEPT_OR_REJECT_INITIATIVE_INVITE = gql`
  mutation Mutation($data: InviteStatusInput!) {
    acceptOrRejectInitiativeInvite(data: $data) {
      success
    }
  }
`;
